import { queryKeys } from '../queryKeys'
import { auditAiRequest } from '../../util/api/audit-ai-api'
import { createDashboardTableHook } from './dashboardHookUtils'
import type {
  DashboardPatientTableResponse,
  DashboardSortableTableOptions,
} from '@counsel-project/counsel-audit-ai-api'

type UseDashboardTablePatientsOptions = {
  sortBy?: DashboardSortableTableOptions['sortBy']
  sortOrder?: DashboardSortableTableOptions['sortOrder']
}

export const useDashboardTablePatients = createDashboardTableHook<
  DashboardPatientTableResponse,
  UseDashboardTablePatientsOptions
>({
  buildQueryKey: queryKeys.dashboardTablePatients,
  request: auditAiRequest.dashboard.tablePatients,
  paginationMode: 'local',
  defaultRowsPerPage: 10,
  getOptionSortBy: (options) => options.sortBy,
  getOptionSortOrder: (options) => options.sortOrder,
})
